var _path, _circle, _circle2, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconEmoji = props => /*#__PURE__*/React.createElement("svg", _extends({
  "data-name": "Layer 1",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12 2A10 10 0 112 12 10 10 0 0112 2zm0 1.67A8.33 8.33 0 1020.33 12 8.33 8.33 0 0012 3.67z"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 15.95,
  cy: 10.13,
  r: 1.26
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 8.05,
  cy: 10.13,
  r: 1.26
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 17.41a4.48 4.48 0 004.52-4.13h-9A4.48 4.48 0 0012 17.41z"
})));

export default SvgIconEmoji;